import initialState from './initialState';
import {USERREG_CHECKLICENSE, USERREG_FETCHTOKENS, USERREG_LICENSECHECKED, USERREG_RECEIVETOKENS} from '../actions/actionTypes';

export function userRegTokens(state = initialState.userReg, action) {

  switch (action.type) {
    case USERREG_FETCHTOKENS:
      return action;
      
    case USERREG_RECEIVETOKENS:
      return action.userReg;

      default:
      return state;
  }
}

export function userRegLicense(state = initialState.license, action) {

  switch (action.type) {
    case USERREG_CHECKLICENSE:
      return action;
      
    case USERREG_LICENSECHECKED:
      return action.license;

      default:
      return state;
  }
}
